<div class="container-fluid company-config-wrapper">
  <div class="row">
    <div class="col-lg-12">
      <div class="card config-card">
        <div class="card-header config-header">
          <div class="header-content">
            <div class="header-icon">
              <i class="fa fa-cog fa-spin"></i>
            </div>
            <div>
              <h5 class="card-title mb-0">
                Company Configuration
              </h5>
              <p class="mb-0 text-muted small">Manage your company's SMTP and authentication settings</p>
            </div>
          </div>
        </div>
        <div class="card-body config-body">
          <nav ngbNav #nav="ngbNav" class="nav-tabs modern-tabs" [destroyOnHide]="false">
            <ng-container ngbNavItem>
              <a ngbNavLink class="tab-link">
                <span class="tab-icon"><i class="fa fa-envelope"></i></span>
                <span class="tab-text">SMTP Config</span>
              </a>
              <ng-template ngbNavContent>
                <div class="tab-content-wrapper">
                  <div class="section-header">
                    <div class="section-icon">
                      <i class="fa fa-server"></i>
                    </div>
                    <div>
                      <h5 class="section-title">SMTP Details</h5>
                      <p class="section-subtitle">Configure your email server settings for sending notifications</p>
                    </div>
                  </div>
                  <form [formGroup]="smtpForm" (ngSubmit)="onSubmit()">
                    <fieldset [disabled]="isDisable">
                      <div class="form-group" hidden>
                        <input type="text" name="id" class="form-control" formControlName="id">
                      </div>
                      
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="Host" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-globe"></i></span>
                              <span class="label-text">Host</span>
                              <sup class="text-danger">*</sup>
                            </label>
                            <div class="input-wrapper">
                              <input type="text" name="host" class="form-control modern-input" formControlName="host" 
                                     placeholder="e.g., smtp.gmail.com">
                              <div class="input-focus-line"></div>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> SMTP server hostname
                            </small>
                            <div *ngIf="submitted && f.host.errors" class="error-message">
                              <i class="fa fa-exclamation-circle"></i>
                              <small *ngIf="f.host.errors.required">Host Name is required.</small>
                            </div>
                          </div>
                        </div>
                        
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="Port" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-plug"></i></span>
                              <span class="label-text">Port</span>
                              <sup class="text-danger">*</sup>
                            </label>
                            <div class="input-wrapper">
                              <input type="number" class="form-control modern-input" name="port" formControlName="port" 
                                     placeholder="e.g., 587">
                              <div class="input-focus-line"></div>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> SMTP server port number
                            </small>
                            <div *ngIf="submitted && f.port.errors" class="error-message">
                              <i class="fa fa-exclamation-circle"></i>
                              <small *ngIf="f.port.errors.required">Port is required.</small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="UserName" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-user"></i></span>
                              <span class="label-text">User Name</span>
                              <sup class="text-danger">*</sup>
                            </label>
                            <div class="input-wrapper">
                              <input type="email" class="form-control modern-input" name="userName" formControlName="userName"
                                     placeholder="e.g., support@digicompany.in">
                              <div class="input-focus-line"></div>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> SMTP authentication email address
                            </small>
                            <div *ngIf="submitted && f.userName.errors" class="error-message">
                              <i class="fa fa-exclamation-circle"></i>
                              <small *ngIf="f.userName.errors.required">User Name is required.</small>
                              <small *ngIf="f.userName.errors.email">Must be a valid email address.</small>
                            </div>
                          </div>
                        </div>
                        
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="Password" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-lock"></i></span>
                              <span class="label-text">Password</span>
                              <sup class="text-danger">*</sup>
                            </label>
                            <div class="input-wrapper password-wrapper">
                              <input [type]="showPassword ? 'text' : 'password'" class="form-control modern-input" name="password" formControlName="password"
                                     placeholder="Enter SMTP password">
                              <div class="input-focus-line"></div>
                              <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                                <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                              </button>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> SMTP authentication password
                            </small>
                            <div *ngIf="submitted && f.password.errors" class="error-message">
                              <i class="fa fa-exclamation-circle"></i>
                              <small *ngIf="f.password.errors.required">Password is required.</small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="SSL" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-shield"></i></span>
                              <span class="label-text">SSL</span>
                              <sup class="text-danger">*</sup>
                            </label>
                            <div class="select-wrapper">
                              <select class="form-control modern-select" name="SSL" formControlName="SSL">
                                <option value="">Select SSL</option>
                                <option value="true">True</option>
                                <option value="false">False</option>
                              </select>
                              <i class="fa fa-chevron-down select-arrow"></i>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> Enable SSL encryption
                            </small>
                            <div *ngIf="submitted && f.SSL.errors" class="error-message">
                              <i class="fa fa-exclamation-circle"></i>
                              <small *ngIf="f.SSL.errors.required">SSL is required.</small>
                            </div>
                          </div>
                        </div>
                        
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="IgnoreTLS" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-ban"></i></span>
                              <span class="label-text">Ignore TLS</span>
                              <sup class="text-danger">*</sup>
                            </label>
                            <div class="select-wrapper">
                              <select class="form-control modern-select" name="ignoreTLS" formControlName="ignoreTLS">
                                <option value="">Select Ignore TLS</option>
                                <option value="true">True</option>
                                <option value="false">False</option>
                              </select>
                              <i class="fa fa-chevron-down select-arrow"></i>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> Ignore TLS certificate validation
                            </small>
                            <div *ngIf="submitted && f.ignoreTLS.errors" class="error-message">
                              <i class="fa fa-exclamation-circle"></i>
                              <small *ngIf="f.ignoreTLS.errors.required">Ignore TLS is required.</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <!-- Test email recipient (always editable, independent of Edit/Save mode) -->
                    <div class="row mt-3">
                      <div class="col-md-6">
                        <div class="form-group modern-form-group">
                          <label for="testEmailTo" class="form-label modern-label">
                            <span class="label-icon"><i class="fa fa-paper-plane"></i></span>
                            <span class="label-text">Test Email To</span>
                            <sup class="text-danger">*</sup>
                          </label>
                          <div class="input-wrapper">
                            <input type="email" class="form-control modern-input" name="testEmailTo" formControlName="testEmailTo"
                                   placeholder="e.g., yourname@company.com">
                            <div class="input-focus-line"></div>
                          </div>
                          <small class="form-text modern-hint">
                            <i class="fa fa-info-circle"></i> Recipient email for the Test SMTP message
                          </small>
                          <div *ngIf="testEmailSubmitted && f.testEmailTo?.errors" class="error-message">
                            <i class="fa fa-exclamation-circle"></i>
                            <small *ngIf="f.testEmailTo?.errors?.email">Must be a valid email address.</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-actions modern-actions">
                      <button type="submit" *ngIf="!isEditable" class="btn btn-modern btn-primary-modern">
                        <i class="fa fa-save"></i>
                        <span>Save Changes</span>
                      </button>
                      <button type="button" class="btn btn-modern btn-primary-modern" *ngIf="isEditable" (click)="onEdit()">
                        <i class="fa fa-edit"></i>
                        <span>Edit</span>
                      </button>
                      <button type="button" class="btn btn-modern btn-info-modern" (click)="onTestSmtp()" [disabled]="isTestingSmtp">
                        <i class="fa" [ngClass]="isTestingSmtp ? 'fa-spinner fa-spin' : 'fa-envelope'"></i>
                        <span>{{ isTestingSmtp ? 'Testing...' : 'Test SMTP' }}</span>
                      </button>
                      <button type="button" *ngIf="!isEditable" class="btn btn-modern btn-secondary-modern" (click)="onCancel()">
                        <i class="fa fa-times"></i>
                        <span>Cancel</span>
                      </button>
                    </div>
                  </form>
                </div>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem>
              <a ngbNavLink class="tab-link">
                <span class="tab-icon"><i class="fa fa-key"></i></span>
                <span class="tab-text">Auth Config</span>
              </a>
              <ng-template ngbNavContent>
                <div class="tab-content-wrapper">
                  <div class="section-header">
                    <div class="section-icon">
                      <i class="fa fa-shield-alt"></i>
                    </div>
                    <div>
                      <h5 class="section-title">Authentication Configuration</h5>
                      <p class="section-subtitle">Manage authentication methods for your organization</p>
                    </div>
                  </div>
                  <form [formGroup]="authForm" (ngSubmit)="onConfigSubmit()">
                    <fieldset>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="towWayConfig" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-mobile-alt"></i></span>
                              <span class="label-text">Two Factor Authentication</span>
                            </label>
                            <div class="select-wrapper">
                              <select name="id" class="form-control modern-select" formControlName="towWayConfig">
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                              <i class="fa fa-chevron-down select-arrow"></i>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> Enable two-factor authentication for enhanced security
                            </small>
                          </div>
                        </div>
                        
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="authLoginConfig" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-sign-in-alt"></i></span>
                              <span class="label-text">OAuth Login Authentication</span>
                            </label>
                            <div class="select-wrapper">
                              <select name="authLoginConfig" class="form-control modern-select" formControlName="authLoginConfig">
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                              <i class="fa fa-chevron-down select-arrow"></i>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> Enable OAuth-based login authentication
                            </small>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row" *ngIf="isADCompany">
                        <div class="col-md-6">
                          <div class="form-group modern-form-group">
                            <label for="OTPLoginFoAD" class="form-label modern-label">
                              <span class="label-icon"><i class="fa fa-keyboard"></i></span>
                              <span class="label-text">OTP Login</span>
                            </label>
                            <div class="select-wrapper">
                              <select name="OTPLoginFoAD" class="form-control modern-select" formControlName="OTPLoginFoAD">
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                              <i class="fa fa-chevron-down select-arrow"></i>
                            </div>
                            <small class="form-text modern-hint">
                              <i class="fa fa-info-circle"></i> Enable OTP-based login for AD users
                            </small>
                          </div>
                        </div>
                      </div>
                      
                      <div class="form-actions modern-actions">
                        <button type="submit" class="btn btn-modern btn-primary-modern">
                          <i class="fa fa-save"></i>
                          <span>Save Configuration</span>
                        </button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </ng-template>
            </ng-container>
          </nav>
          <div [ngbNavOutlet]="nav" class="mt-3"></div> 
        </div>
      </div>
    </div>
  </div>
</div>
<app-alert></app-alert>